module.exports = __webpack_public_path__ + "img/logo02.08bf9d40.svg";